import yup from '../../../config/yup/customYup';

export default yup
  .object({
    description: yup.string().required(),
    migrationType: yup.number().required(),
  })
  .required();
